import { Suspense, useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import '../case-studies.css';
import CaseStudyPageHero from './components/hero';
import LoadingScreen from '../../../components/loader/loading-screen';
import { CaseStudyContentConfig, caseStudyUrlRouting } from '../../../config/case-study-content-config';
import IotCaseStudy from './pages/iot-case-study';
import AICaseStudy from './pages/ai-case-study';
import CloudCaseStudy from './pages/cloud-case-study';
import DevopsCaseStudy from './pages/devops-case-study';
import AutomationCaseStudy from './pages/automation-case-study';
import CrossPlatformCaseStudy from './pages/cross-platform-case-study';
import TestimonialCarousel from '../../../components/carousels/testimonial-carousel';
import ContactForm from '../../../components/forms/contact-form';
import ProductPartners from '../../../components/product-partners';
import { useNavigate } from 'react-router-dom';
import OcrCaseStudy from './pages/ocr-case-study';
import EmrCaseStudy from './pages/emr-case-study';
import AndroidCaseStudy from './pages/android-case-study';
import BlockchainCaseStudy from './pages/blockchain-case-study';

const CaseStudyBaseLayout = () => {

    const navigate = useNavigate()
    const handlePageLink = (path) => {
        navigate(path);
    }

    const [page, setPage] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const currentPath = window.location.pathname;

        const findPath = caseStudyUrlRouting.find(
            (data) => data.pathname === currentPath
        );
        const newPage = CaseStudyContentConfig.find(
            (data) => data.pageName === findPath?.pageName
        );

        if (newPage) {
            setPage(newPage);
        }
    }, [location.pathname]);

    if (!page) return <LoadingScreen />;

    const renderCaseStudyComponent = () => {
        switch (page.pageName) {
            case 'iot-case-study':
                return <IotCaseStudy />;
            case 'ai-case-study':
                return <AICaseStudy />;
            case 'cloud-case-study':
                return <CloudCaseStudy />;
            case 'devops-case-study':
                return <DevopsCaseStudy />;
            case 'automation-case-study':
                return <AutomationCaseStudy />;
            case 'crossplatform-case-study':
                return <CrossPlatformCaseStudy />;
            case 'emr-case-study':
                return <EmrCaseStudy />;
            case 'ocr-case-study':
                return <OcrCaseStudy />;
            case 'blockchain-case-study':
                return <BlockchainCaseStudy />;
            case 'android-case-study':
                return <AndroidCaseStudy />;
            default:
                return null;
        }
    };

    const renderReadMoreSection = () => {
        // Filter out the current active case study
        const otherCaseStudies = CaseStudyContentConfig.filter(
            (study) => study.pageName !== page.pageName
        );

        // Randomly select three case studies
        const randomCaseStudies = otherCaseStudies
            .sort(() => 0.5 - Math.random())
            .slice(0, 3);


        return (
            <Container fluid className="py-4">
                <h2 className="text-primary text-center ft-wt-700 mb-4">Read More</h2>
                <Row>
                    {randomCaseStudies.map((study, index) => (
                        <Col xs={12} lg={4} className="mb-4" key={index}>
                            <Card className="h-100">
                                <div className="case-study-card">
                                    <Card.Img src={study.backgroundImage} alt={study.title} />
                                </div>
                                <Card.Body className="caseStudy-card-body">
                                    <Card.Title className="text-primary fw-bold mb-3">
                                        {study.title}
                                    </Card.Title>
                                    <Button variant="primary" onClick={() =>
                                        handlePageLink(study.url)
                                    }>
                                        Learn More
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <div className="text-center mt-4">
                    <Button variant="primary" onClick={() => handlePageLink("/resources/case_study")}>
                        View More Case Studies
                    </Button>
                </div>
            </Container>
        );
    };

    return (
        <Suspense fallback={<LoadingScreen />}>
            <section className="case-study-layout">
                <CaseStudyPageHero
                    backgroundImage={page.backgroundImage}
                    title={page.title}
                />
                {renderCaseStudyComponent()}
                {renderReadMoreSection()}
                <TestimonialCarousel />
                <ContactForm />
                <ProductPartners />
            </section>
        </Suspense>
    );
};

export default CaseStudyBaseLayout;
